var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":""},on:{"click":_vm.submit}},[_c('v-icon',[_vm._v("mdi-briefcase-download")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }